<ion-content>
    <div class="select-number">
        <div class="title">
            <h2>
                <ion-text color="primary">
                    {{ title | translate }}
                </ion-text>
            </h2>
        </div>
        <mat-form-field>
            <mat-label>Tempo de abertura</mat-label>
            <mat-select [(value)]="selectedNumber">
                <mat-option *ngFor="let number of options" [value]="number">
                    {{ number }} {{ "generic.hours" | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="actions">
            <ion-button fill="outline" 
                (click)="cancel()"
            >
                {{ 'generic.cancel' | translate }}
            </ion-button>
            <ion-button
                    mode="ios"
                    color="primary"
                    (click)="save()">
                {{ 'generic.save' | translate }}
            </ion-button>
        </div>
    </div>
</ion-content>